import store from '@/store'

export function isAdminRole(roles) {
  const isAdmin = store.getters && store.getters.isAdmin
  if (isAdmin || roles.includes('admin')) {
    return true
  }
  return false
}

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(value, ignoreAdmin = false) {
  const roles = store.getters && store.getters.roles
  //  && value.length > 0
  if (value && value instanceof Array) {
    // 写在里面是为了避免 value不合法造成潜在的bug
    if (isAdminRole(roles) && !ignoreAdmin) {
      return true
    }
    let permissionRoles
    if (store.state.permission.permissionSeparateOffice) {
      permissionRoles = Array.from(value, p => `${store.getters.currentOfficeId}_${p}`)
    } else {
      permissionRoles = value
    }
    const hasPermission = roles.some(role => {
      return permissionRoles.includes(role)
    })

    return !!hasPermission
  } else {
    console.error(`need roles! Like v-permission="['admin','editor']"`)
    return false
  }
}

export function getCargoJumpUrl({ code, language, sessionId, branchId, reportId = null, departmentId, sopCode = null, sopSubCode = null, etdStart = null, etdEnd = null, jobState = null, jobNo = null }) {
  const url = `${process.env.VUE_APP_CARGO}/ssoForward?sessionId=${sessionId || store.getters.currentUserInfo.sessionId}&branchId=${branchId || store.getters.currentOfficeId}&departmentId=${departmentId || store.getters.currentDeptId}&language=${language || store.getters.language}&module=${code}&reportId=${reportId}&sopCode=${sopCode}&sopSubCode=${sopSubCode}&etdStart=${etdStart}&etdEnd=${etdEnd}&jobState=${jobState}&jobNo=${jobNo}`
  return url
}

